import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import LoadingWithText from '../LoadingWithText/LoadingWithText'

import IpsaContext from '../../context/IpsaContext'

const PrivateRoute = ({
    component: Component,
    layout: Layout,
    path,
    subscriptionLevelsRequired,
    ...rest
}) => {
    const { isAuthenticated } = useAuth0()
    const {
        subscription: { status, level },
    } = useContext(IpsaContext)

    if (!status) {
        return (
            <LoadingWithText text="No current subscription information for the logged in user. Contact support." />
        )
    }

    // Check current user subscription level vs required subscription levels
    // Must also have an active plan or will be directed to account page automatically
    if (subscriptionLevelsRequired && subscriptionLevelsRequired.length > 0) {
        if (
            status !== 'Active' &&
            status !== 'Trialing' &&
            (path !== '/account/subscription' || path !== '/account/subscription/freetrial')
        ) {
            if (path === '/freetrial') {
                return <Redirect push to="account/subscription/freetrial" />
            } else {
                return <Redirect push to="account/subscription" />
            }
        }

        //allow any plan
        //if (!subscriptionLevelsRequired.includes(level)) {
        if (!level) {
            return <Redirect push to="/" />
        }
    }

    const render = (props) =>
        isAuthenticated ? (
            <Layout>
                <Component {...props} />
            </Layout>
        ) : null
    return <Route path={path} render={render} {...rest} />
}

export default PrivateRoute
